import { API_BASE, buildQuery, request } from './api-client';
import type {
  AdminProductRow,
  CreateProductInput,
  EditProductInput,
  Paginated,
  ProductListQuery,
} from '../types';

const BASE = `${API_BASE}/admin/collections`;

export function listProducts(query: ProductListQuery) {
  return request<Paginated<AdminProductRow>>(`${BASE}${buildQuery(query as Record<string, unknown>)}`);
}

export function getProduct(id: string) {
  return request<AdminProductRow>(`${BASE}/${id}`);
}

export function createProduct(input: CreateProductInput) {
  return request<AdminProductRow>(BASE, { method: 'POST', body: JSON.stringify(input) });
}

export function editProduct(id: string, input: EditProductInput) {
  return request<AdminProductRow>(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

/** Distinct from `editProduct` — reprice always creates a new version (backend §8). Never used for a plain field edit. */
export function repriceProduct(id: string, amountInPaise: number) {
  return request<AdminProductRow>(`${BASE}/${id}/reprice`, {
    method: 'POST',
    body: JSON.stringify({ amountInPaise }),
  });
}

export function activateProduct(id: string) {
  return request<AdminProductRow>(`${BASE}/${id}/activate`, { method: 'POST' });
}

export function deactivateProduct(id: string) {
  return request<AdminProductRow>(`${BASE}/${id}/deactivate`, { method: 'POST' });
}
